import {
  EtxeApiPrefixes,
  PropertyApplicationDto,
  PropertyApplicationId,
  PropertyId,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';

export class PropertyApplicationsOwnerConnector extends ApiConnector<
  PropertyApplicationDto,
  PropertyApplicationDto,
  PropertyApplicationId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string, parentSlug: string) {
    super(apiCaller, apiPrefix, `${parentSlug}/owner`);
  }

  listForProperty = (propertyId: PropertyId): Observable<PropertyApplicationDto[]> =>
    this.apiCaller.getRequest<PropertyApplicationDto[]>(
      EtxeApiPrefixes.CORE,
      `${this.slug}/property/${propertyId}`,
    );

  override get = (applicationId: PropertyApplicationId): Observable<PropertyApplicationDto> =>
    this.apiCaller.getRequest<PropertyApplicationDto>(EtxeApiPrefixes.CORE, `${this.slug}/${applicationId}`);

  accept = (applicationId: PropertyApplicationId): Observable<PropertyApplicationDto> =>
    this.apiCaller.postRequest<PropertyApplicationDto>(
      EtxeApiPrefixes.CORE,
      `${this.slug}/${applicationId}/accept`,
    );

  reject = (applicationId: PropertyApplicationId): Observable<PropertyApplicationDto> =>
    this.apiCaller.postRequest<PropertyApplicationDto>(
      EtxeApiPrefixes.CORE,
      `${this.slug}/${applicationId}/reject`,
    );
}
